export default "__VITE_ASSET__pB4BXYpR__"